import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ConvertToString from "../../../components/Converter";
import Millimetre from "../../../components/Math/Units/Metric/Millimetre";
import RenderFor, { BM_TYP } from "../../../components/RenderFor";
import { RowBody } from "../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../components/ToolTip";
import {
  BemessungenMikropfaehle,
  selectBemessungenMikropfaehle,
} from "../../../store/slices/bemessungenMikropfaehleSlice";

function Widening({ aMin }) {
  const { t } = useTranslation("translation");
  const bemessungenMikropfaehle = useSelector(selectBemessungenMikropfaehle);

  return (
    <RowBody
      titleValue={
        <p>
          {bemessungenMikropfaehle === BemessungenMikropfaehle.EUROCODE_7
            ? t("inner.verificationCapacity.widening_ec7")
            : t("inner.verificationCapacity.widening")}
        </p>
      }
      indicesValue={
        <span>
          a<sub>min</sub>
        </span>
      }
      formulaValue={
        <RenderFor types={[BM_TYP.EUROCODE_7]}>
          <ToolTip
            id={"Widening"}
            type={IconType.INFO}
            text={t("inner.verificationCapacity.wideningInfo_ec7")}
          />
        </RenderFor>
      }
      inputValue={<span className="input">{ConvertToString(aMin)}</span>}
      unitValue={<Millimetre />}
    />
  );
}

export default Widening;
